import { useSelector } from 'react-redux';

import { selectFeature } from 'selectors/features';

export const useFeature = (feature: string) => useSelector(state => selectFeature(feature, state));
